// CollapsedMessage — Presentational hint shown when results are collapsed.
//
// Extracted VERBATIM from `components/RestaurantSearch.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// and text are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';

export const CollapsedMessage = React.memo(function CollapsedMessage() {
  return (
    <div style={{
      textAlign: 'center', padding: '20px', color: '#6b7280',
      fontSize: '14px', fontStyle: 'italic'
    }}>
      Results are hidden. Click "Show Results" above to view.
    </div>
  );
});

export default CollapsedMessage;
